"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Module that provides the registry object to be used for all
 * players on the page.
 *
 * @module registry
 */
var _default = exports["default"] = {
  theo: {
    requested: false,
    ready: false,
    players: {},
    youbora: null
  },
  jw: {
    requested: false,
    ready: false,
    players: {}
  }
};